import { useIntl } from 'react-intl';
import { BaseGlobalReportPage } from '../common/GlobalReportPage';
import { ConsecutiveSchedulesReportView } from './ConsecutiveSchedulesReportView';

type Props = Record<string, never>;

export function GlobalConsecutiveSchedulesReportPage(p: Props) {
  const { $t } = useIntl();

  return (
    <BaseGlobalReportPage
      title={$t({
        id: 'audit.consecutiveSchedules.title',
        defaultMessage: 'Schedules consecutivos',
      })}
    >
      <ConsecutiveSchedulesReportView />
    </BaseGlobalReportPage>
  );
}
